import { StandardProps } from "../componentMap";
import { useVariant } from "@/hooks/useVariant/useVariant.ts";
import { EnergyLabelUI } from "./EnergyLabelUI";

export const EnergyLabel = ({
  product,
  flags,
}: Pick<StandardProps, "product" | "flags" | "configProps">) => {
  const { variant } = useVariant(product);

  if (!variant.energy) {
    return null;
  }

  const {
    label,
    informationSheet,
    rating: { legacy, value },
  } = variant.energy;

  return (
    <EnergyLabelUI
      informationSheet={informationSheet || undefined}
      isLegacy={!!legacy}
      label={label || undefined}
      rating={value}
      openDrawerEvent={String(flags.energyLabelOnOpenDrawerEvent.value)}
      closeDrawerEvent={String(flags.energyLabelOnCloseDrawerEvent.value)}
    />
  );
};
